import React from "react";
import { Group, ActionIcon } from "@mantine/core";
import { ReactComponent as DeleteIcon } from "@/assets/icons/delete.svg";
import { ReactComponent as ProfileIcon } from "@/assets/icons/profile.svg";
import { ReactComponent as ChevronRightIcon } from "@/assets/icons/chevron-right.svg";
import { ReactComponent as HistoryIcon } from "@/assets/icons/history.svg";
import { ReactComponent as SubscriptionIcon } from "@/assets/icons/subscription.svg";
import { ReactComponent as BackIcon } from "@/assets/icons/back.svg";
import { ReactComponent as LogoutIcon } from "@/assets/icons/logout.svg";
import PersonalData from "@/components/User/Profile/Steps/PersonalData";
import Subscription from "@/components/User/Profile/Steps/Subscription";
import Password from "@/components/User/Profile/Steps/Password";
import History from "@/components/User/Profile/Steps/History";
import dayjs from "dayjs";
import "./MobileView.css";
import {
  UserSubscription,
  Subscription as SubscriptionType,
  Order,
} from "@/api/types";
import {
  PersonalDataFormType,
  PasswordFormType,
} from "@/pages/User/Profile/Profile";

interface MobileViewProps {
  mobileStep: string;
  setMobileStep: (step: string) => void;
  activeSubscription?: UserSubscription | null;
  subscriptionData?: SubscriptionType;
  orders?: Order[];
  personalDataForm: PersonalDataFormType;
  saveMyDetails: (values: PersonalDataFormType["values"]) => void;
  passwordForm: PasswordFormType;
  setNewPassword: (values: PasswordFormType["values"]) => void;
  logoutHandler: () => void;
  open: () => void;
}

const MobileView: React.FC<MobileViewProps> = ({
  mobileStep,
  setMobileStep,
  activeSubscription,
  subscriptionData,
  orders,
  personalDataForm,
  saveMyDetails,
  passwordForm,
  setNewPassword,
  logoutHandler,
  open,
}) => {
  return (
    <div className="profile-mobile-view">
      {!mobileStep ? (
        <div>
          <div
            className="flex justify-between items-center p-[1.5rem] border-b border-[#eaeaea] cursor-pointer"
            onClick={() => setMobileStep("personalData")}
          >
            <div className="flex gap-4 items-center">
              <ProfileIcon width={16} height={16} className="text-[#004a99]" />
              <div className="text-[#004a99] text-base font-bold">
                Osobni podaci
              </div>
            </div>
            <ChevronRightIcon className="text-[#004a99]" />
          </div>
          <div
            className="flex justify-between items-center p-[1.5rem] border-b border-[#eaeaea] cursor-pointer"
            onClick={() => setMobileStep("subscription")}
          >
            <div className="flex flex-col">
              <div className="flex gap-4 items-center">
                <SubscriptionIcon className="text-[#004a99]" />
                <div className="text-[#004a99] text-base font-bold">
                  Pretplata
                </div>
              </div>
              {activeSubscription ? (
                <div className="flex flex-col pl-8">
                  <div className="text-[#0b1a29] text-sm font-medium">
                    {activeSubscription?.subscription?.title ??
                      "Godišnja pretplata"}
                  </div>
                  <div className="text-[#515151] text-sm font-medium">
                    Aktivno do:{" "}
                    {dayjs(activeSubscription?.endDate).format("DD.MM.YYYY.")}
                  </div>
                </div>
              ) : (
                <div className="flex flex-col pl-8">
                  <div className="text-[#0b1a29] text-sm font-medium">
                    Trenutno nema aktivne pretplate
                  </div>
                </div>
              )}
            </div>
            <ChevronRightIcon className="text-[#004a99]" />
          </div>
          <div
            className="flex justify-between items-center p-[1.5rem] border-b border-[#eaeaea] cursor-pointer"
            onClick={() => setMobileStep("history")}
          >
            <div className="flex gap-4 items-center">
              <HistoryIcon className="text-[#004a99]" />
              <div className="text-[#004a99] text-base font-bold">
                Povijest kupovine
              </div>
            </div>
            <ChevronRightIcon className="text-[#004a99]" />
          </div>
          <div
            className="flex gap-4 items-center p-[1.5rem] border-b border-[#eaeaea] cursor-pointer"
            onClick={logoutHandler}
          >
            <LogoutIcon className="text-[#525252]" />
            <div className="text-[#525252] text-base font-bold">Odjava</div>
          </div>
          <div
            className="flex gap-4 items-center p-[1.5rem]"
            onClick={() => open()}
          >
            <DeleteIcon className="text-[#fc4a4a]" />
            <div className="text-[#fc4a4a] text-base font-bold">
              Obriši račun
            </div>
          </div>
        </div>
      ) : (
        <div className="flex flex-col h-full">
          <Group
            className="cursor-pointer hover:opacity-80 p-4"
            onClick={() => {
              setMobileStep(mobileStep === "password" ? "personalData" : "");
            }}
          >
            <ActionIcon
              variant="filled"
              size="lg"
              radius="xl"
              className="!bg-[#f4f4f4] !p-2"
            >
              <BackIcon fill="#0B1A29" />
            </ActionIcon>
            <div className="text-[#0b1a29] text-base font-bold">
              {mobileStep === "password" ? "Natrag" : "Natrag na Profil"}
            </div>
          </Group>

          {mobileStep === "personalData" ? (
            <PersonalData
              formData={personalDataForm}
              saveMyDetails={saveMyDetails}
              goToPassword={() => setMobileStep("password")}
            />
          ) : mobileStep === "subscription" ? (
            <Subscription
              activeSubscription={activeSubscription}
              subscriptionData={subscriptionData}
              orders={orders}
            />
          ) : mobileStep === "password" ? (
            <Password formData={passwordForm} setNewPassword={setNewPassword} />
          ) : (
            mobileStep === "history" && <History orders={orders} />
          )}
        </div>
      )}
    </div>
  );
};

export default MobileView;
